import { OutletContextType } from 'hooks/useOutletSite/useOutletSite.types';
import { useOutletContext } from 'react-router';

export function useOutletSite() {
  return useOutletContext<OutletContextType>();
}
